module.exports = __webpack_public_path__ + "static/media/dataPins.865652ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img/dataPins.png
// module id = 452
// module chunks = 0